// Wrapper for Cancelletion token sending to backend
export class AbortControllerManager {
  private controllers: Map<string, AbortController> = new Map();

  create(key: string) {
    this.abort(key);

    const controller = new AbortController();
    this.controllers.set(key, controller);

    return controller;
  }

  abort(key: string) {
    const controller = this.controllers.get(key);
    if (controller) {
      controller.abort();
      this.controllers.delete(key);
    }
  }

  remove(key: string) {
    this.controllers.delete(key);
  }

  abortAll() {
    this.controllers.forEach(c => c.abort());
    this.controllers.clear();
  }

  clear(){
    this.controllers.clear();
  }
}